import { EntityStore } from "./entity-implementations";
import { LoggingService } from "../loggingSvc";

/** RootStore provides api to create and observe store changes */
export class RootStoreImplementation {
  private entityStores: Map<string, EntityStore<any>> = new Map<string, EntityStore<any>>();

  constructor() {}

  /**
   * Add an instance to root store
   * @param {string} entityType - Entity type name.
   * @param {Store<T>} store - Store of entity type to be added.
   */
  private add<T>(entityType: string, store: EntityStore<T>): EntityStore<T> {
    this.entityStores.set(entityType, store);
    return store;
  }

  /**
   * Get entity store based on entity type name.
   * @param {string} entityType - Entity type name.
   */
  public createAndGetStore<T>(entityType: string, loggingSvc: LoggingService): EntityStore<T> {
    let existingStore = this.entityStores.get(entityType);
    if (!existingStore) {
      existingStore = new EntityStore<T>(entityType, loggingSvc);
      this.add(entityType, existingStore);
    }
    return existingStore;
  }
}
